<!-- 编辑弹窗 -->
<template>
  <el-dialog
        title="编辑收货地址"
        :visible.sync="addVisible"
        width="90%"
        class="patRecord-dialog"
        @close="handleClose"
    >
        <el-form ref="address-form" :model="formData" :rules="rules">
          <el-form-item label="收件人：" prop="recipient">
            <el-input v-model="formData.recipient" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="telephone">
            <el-input v-model="formData.telephone" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="所在地区：" prop="provinceCity">
            <el-input v-model="formData.provinceCity" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input v-model="formData.address" type="textarea" :rows="3" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="success" size="medium" @click="submit">确 认</el-button>
            <el-button type="danger" size="medium" @click="handleClose">关 闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { addAddressApi, getPatAddressApi } from '../../api/appletApi.js'
export default {
  name: 'editAddressDialog',
  mixins: [],
  components: {},
  props: {
    visible: {
      Boolean,
      default: false
    },
    chatItem: {
      Object,
      default: () => {}
    },
    patInfo: {
      Object,
      default: () => {}
    }
  },
  data () {
    return {
      addVisible: false,
      formData: {
        recipient: '',
        telephone: '',
        provinceCity: '',
        address: ''
      },
      rules: {
        recipient: [{ required: true, message: '请输入收件人', trigger: 'blur' }],
        telephone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        provinceCity: [{ required: true, message: '请输入所在地区', trigger: 'blur' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible (val) {
      this.addVisible = val
      if (val) {
        this.getPatAddress()
      }
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    getPatAddress () { // 获取患者地址
      let params = {
        addressId: this.chatItem.content.addressId,
        patId: this.patInfo.patId
      }
      getPatAddressApi(params).then(data => {
        if (data) {
          this.formData = data
        }
      })
    },
    submit () { // 收货地址保存
      this.$refs['address-form'].validate((valid) => {
        if (valid) {
          let params = {
            ...this.formData,
            patId: this.patInfo.patId
          }
          addAddressApi(params).then(data => {
            if (data) {
              this.$message.success('保存收货地址成功')
              this.handleClose()
              this.chatItem.content.receiptInfo = this.formData.provinceCity + this.formData.address
            }
          })
        }
      })
    },
    handleClose () { // 新增收货地址弹窗关闭
      this.$emit('update:visible', false)
      this.$refs['address-form'].resetFields()
    }
  },
  beforeDestroy () {},
  destroyed () {}
}
</script>
<style lang='scss' scoped>
.patRecord-dialog{
    /deep/ .el-dialog{
        border-radius: 8px;
        .el-dialog__body{
            padding: 0 15px 15px 15px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// packages/chat/src/editAddressDialog.vue